import { render, staticRenderFns } from "./Assistindex.vue?vue&type=template&id=3b5d5299"
import script from "./Assistindex.vue?vue&type=script&lang=js"
export * from "./Assistindex.vue?vue&type=script&lang=js"
import style0 from "./Assistindex.vue?vue&type=style&index=0&id=3b5d5299&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports